// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { uniqueBy } from '../../../../utils/array';

import { ProfileImageWithFallback } from './ProfileImageWithFallback';
import { AvatarSkeleton, CircleImage } from './styled-components';

// Component
const ProfileImageCircles = ({
  border,
  boxShadow,
  height,
  images,
  localImages,
  marginRight,
  width,
  presentationOnly,
}) => {
  const loading = !localImages?.length && !images?.length;
  const uniqueImages = uniqueBy(images, 'name') || [];

  return (
    <CircleImage
      border={border}
      boxShadow={boxShadow}
      height={height}
      marginRight={marginRight}
      width={width}
    >
      <AvatarSkeleton
        active
        avatar
        height={height}
        loading={loading}
        paragraph={false}
        title={false}
        width={width}
      />
      {!loading
      && uniqueImages
        .slice(0, 3)
        .map((pic, i) => (
          <ProfileImageWithFallback
            key={pic.id || i}
            pic={pic}
            presentationOnly={presentationOnly}
          />
        ))}
      {localImages?.map((localSrc) =>
        <ProfileImageWithFallback key={localSrc} localSrc={localSrc} />)}
    </CircleImage>
  );
};

ProfileImageCircles.propTypes = {
  border: PropTypes.string,
  boxShadow: PropTypes.string,
  height: PropTypes.string,
  images: PropTypes.array,
  localImages: PropTypes.array,
  marginRight: PropTypes.string,
  width: PropTypes.string,
  presentationOnly: PropTypes.bool,
};

export default ProfileImageCircles;
